<template>
	<b-card>
		<div slot="header">
			<div class="justify-content-between d-flex">
				<h5 class="mb-0" style="white-space: nowrap">{{ $t('users-l.create.add-new-user') }}</h5>
			</div>
		</div>
		<b-card-body>
			<div v-if="loading" class="text-center">
				<b-spinner small class="mr-2" /><strong>Loading...</strong>
			</div>
			<div class="row">
				<div class="col-4">
					<b-form-group :label="`${$t('pricing.department')}:`" label-class="text-sm-left" label-for="lastName">
						<multiselect :disabled="loading" v-model="form.departmentId" :options="departmentList" track-by="id"
							:show-labels="false" :allow-empty="true" label="name" :placeholder="$t('pricing.department')"
							class="multiselect-pricing" />
					</b-form-group>
				</div>
				<div class="col-4">
					<b-form-group :label="`${$t('employees.create.last-name')}:`" label-class="text-sm-left"
						label-for="lastName">
						<b-form-input :disabled="loading" id="lastName" v-model="form.lastName" />
					</b-form-group>
				</div>
				<div class="col-4">
					<b-form-group :label="`${$t('employees.create.first-name')}:`" label-class="text-sm-left"
						label-for="firstName">
						<b-form-input :disabled="loading" id="firstName" v-model="form.firstName" />
					</b-form-group>
				</div>
				<div class="col-4">
					<b-form-group :label="`${$t('employees.create.middle-name')}:`" label-class="text-sm-left"
						label-for="middleName">
						<b-form-input :disabled="loading" id="middleName" v-model="form.middleName" />
					</b-form-group>
				</div>
				<div class="col-4">
					<b-form-group :label="`${$t('employees.gender')}:`" label-class="text-sm-left" label-for="lastName">
						<multiselect :disabled="loading" v-model="form.gender" :options="genderList" track-by="id"
							:show-labels="false" :allow-empty="true" label="name" class="multiselect-pricing"
							:placeholder="$t('employees.gender')" />
					</b-form-group>
				</div>
				<div class="col-4">
					<b-form-group :label="`${$t('users-l.username')}:`" label-class="text-sm-left" label-for="username">
						<b-form-input :disabled="loading" id="username" v-model="form.username" />
					</b-form-group>
				</div>
				<div class="col-4">
					<b-form-group :label="`${$t('users-l.create.password')}:`" label-class="text-sm-left"
						label-for="password">
						<b-form-input :disabled="loading" id="password" v-model="form.password" type="password" />
					</b-form-group>
				</div>
				<div class="col-12">
					<b-button :disabled="loading" v-on:click.prevent="save" type="submit" variant="primary">
						Сохранить
					</b-button>
				</div>
			</div>
		</b-card-body>
	</b-card>
</template>
<script>
import { TokenService } from "../../../services/storage.service";
import EmployeeSerive from "../../../services/employees.service";
import UsersService from "../../../services/users.sevice";
import Multiselect from "vue-multiselect";

export default {
	name: "CreateUser",
	components: { Multiselect },
	data: () => {
		return {
			loading: false,
			form: {
				gender: '',
				lastName: '',
				username: '',
				password: '',
				firstName: '',
				middleName: '',
				departmentId: '',
			},
			departmentList: [],
			genderList: [
				{
					id: 'FEMALE',
					name: 'Ayol',
				},
				{
					id: 'MALE',
					name: 'Erkak',
				},
			],
		}
	},

	methods: {
		save() {
			this.loading = true;

			EmployeeSerive.addEmployeeWithUser({ ...this.form, gender: this.form.gender.id, departmentId: this.form.departmentId.id }).then(response => {

				this.form = {
					gender: '',
					lastName: '',
					username: '',
					password: '',
					firstName: '',
					middleName: '',
					departmentId: '',
				}

				this.$vs.notify({
					text: this.$t('action_success'),
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
			}).catch(error => {
				if (error.request) {
					let message = JSON.stringify(error.request.response.message)
					this.$vs.notify({
						text: 'Error: ' + message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}
			}).finally(() => {
				this.loading = false
			})
		},
		async getDepartmentList() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departmentList = response.data.permittedDepartments
			})
		},
	},
	created() {
		this.getDepartmentList();
	},
}
</script>

<style scoped></style>
